import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = self.customSetting.OSHController;
const getController = self.customSetting.getOSH;
const postController = self.customSetting.postOSH;

export default {
  // 3-3
  getWorkAreaCondition: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryConditionList`)
        .then((res) => {
          context.commit("GET_WORKAREA_COND", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getWorkArea: (context, id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryWorkAreaList?ld1=${id}`)
        .then((res) => {
          context.commit("GET_WORKAREA_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addWorkArea: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/ModifyArea`, data)
        .then((res) => {
          context.commit("GET_WORKAREA_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delWorkArea: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/DeleteArea`, data)
        .then((res) => {
          context.commit("GET_WORKAREA_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSignoffStaffCondition: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QrySignOffCondition`)
        .then((res) => {
          context.commit("GET_SIGNOFF_COND", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSecondArea: (context, { fac, location }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/QrySecondArea?location_type_id=${location}&ld1=${fac}`
        )
        .then((res) => {
          context.commit("GET_SECONDAREA_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getWorkerList: (context, keyword) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryEmp?word=${keyword}`)
        .then((res) => {
          context.commit("GET_WORKER_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addSignoffStaff: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsAreaMember`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSignoffStaff: (context, { fac, location }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/QrySignOffList?ld1=${fac}&location_type_id=${location}`
        )
        .then((res) => {
          context.commit("GET_SIGNOFF_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSignoffStaffDetail: (
    context,
    { area_Id, ld1, location_Type_Id, area_Type }
  ) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/QuerySignOffDetail?area_Id=${area_Id}&ld1=${ld1}&location_Type_Id=${location_Type_Id}&area_Type=${area_Type}`
        )
        .then((res) => {
          context.commit("GET_SIGNOFF_DETAIL", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delSignoffStaff: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/DelSignoffDetail`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 3-4~3-5
  getAllFacList: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryFacs`)
        .then((res) => {
          context.commit("GET_ALL_FACLIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAllRoomList: (context, { location_type, ld1 }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/QryResponsePeople?location_type=${location_type}&ld1=${ld1}`
        )
        .then((res) => {
          context.commit("GET_ALL_ROOMLIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delSingleRoom: (context, fab_Approve_Id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/DelResponsePeople?fab_Approve_Id=${fab_Approve_Id}`
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addNonDustless: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsMainArea`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getNonDustlessFabList: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryResponsePeopleForZero`)
        .then((res) => {
          context.commit("GET_NONDUSTLESS_FABLIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updNonDustless: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/ModifyResponsePeople`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addDustless: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsMainAreaForNone`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDustlessFabList: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryResponsePeopleForNone`)
        .then((res) => {
          context.commit("GET_DUSTLESS_FABLIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updDustless: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/ModifyResponsePeopleForNone`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 3-6
  getHighrisk: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryHighRisk`)
        .then((res) => {
          context.commit("GET_HIGHRISK_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addHighrisk: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/AddHighRisk`, data)
        .then((res) => {
          context.commit("GET_HIGHRISK_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updHighrisk: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdHighRisk`, data)
        .then((res) => {
          context.commit("GET_HIGHRISK_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 3-7
  OSHQryInsuranceCondition: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryInsuranceCondition`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  OSHQryInsuranceList: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryInsuranceList?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  OSHUpdInsuranceNotify: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdInsuranceNotify`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 3-8~3-11
  OSHQryFacMaster: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryFacMaster?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  OSHUpdFacMaster: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdFacMaster`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  OSHQrySecondAreaSignOff: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QrySecondAreaSignOff?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  OSHUpdSecondAreaSignOff: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdSecondAreaSignOff`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  OSHQryProcessor: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryProcessor?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  OSHUpdProcessor: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdProcessor`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 3-12
  getContract: (context, keyword) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryPrjEngineer?emp_no=${keyword}`)
        .then((res) => {
          context.commit("GET_CONTRACT_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updContract: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdPrjEngineer`, data)
        .then((res) => {
          context.commit("GET_CONTRACT_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
